import React from "react";
import style from './Footer.module.css'

export const Footer = () => {
    return (
        <div className={style.footer}>
            <div className={style.footerWrapper}>

            </div>

            <div className={style.divider}>

            </div>

            <div className={style.codewarsBadges}>
                <img src="https://www.codewars.com/users/arturexponee/badges/large" alt=""/>
            </div>
        </div>

    )
}